module.exports = __webpack_public_path__ + "img/edit-light.02b376c7.svg";